import Page from 'components/layout/Page';
import { StyledManfredite } from './ManfrediteComponent.styled';
import ManfrediteHelp from './ManfrediteHelp';
import ManfrediteIntro from './ManfrediteIntro';
import ManfreditePath from './ManfreditePath';

const ManfrediteComponent: React.FC = () => {
  return (
    <Page>
      <StyledManfredite>
        <ManfrediteIntro />
        <ManfreditePath />
        <ManfrediteHelp />
      </StyledManfredite>
    </Page>
  );
};

export default ManfrediteComponent;
